import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Approach from "@/pages/Approach";
import Work from "@/pages/Work";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Framework from "@/pages/Framework";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import SmsTerms from "@/pages/legal/SmsTerms";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/admin/Admin";
import CampaignSetup from "@/pages/CampaignSetup";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <AnimatePresence mode="wait">
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:slug" element={<ServiceDetail />} />
                <Route path="/approach" element={<Approach />} />
                <Route path="/work" element={<Work />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/framework" element={<Framework />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/sms-terms" element={<SmsTerms />} />
                <Route path="/onetimecampaignsetup" element={<CampaignSetup />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </AnimatePresence>
        </SmoothScroll>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#141414",
              border: "1px solid rgba(255,255,255,0.10)",
              color: "#F3EFE6",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
